import type {
    AgreementHistoryEvent,
    HistoryPage,
    MotorplanPaymentHistoryEvent,
} from '../types/agreementTimeline.types';

export const PAYMENT_SCAN_PAGE_CAP = 4;

const isReceived = (entry: AgreementHistoryEvent): entry is MotorplanPaymentHistoryEvent =>
    entry.kind === 'motorplan_payment_received' && entry.paymentType === 'ad_hoc';

/** The newest ad hoc MotorPlan payment received at or after `sinceIso`; a payment closes only links created before it. */
export function paymentReceivedSince(
    entries: AgreementHistoryEvent[],
    sinceIso: string,
): MotorplanPaymentHistoryEvent | null {
    const since = Date.parse(sinceIso);
    if (Number.isNaN(since)) return null;
    let newest: MotorplanPaymentHistoryEvent | null = null;
    let newestAt = -Infinity;
    for (const entry of entries) {
        const occurredAt = Date.parse(entry.occurredAt);
        if (!isReceived(entry) || Number.isNaN(occurredAt) || occurredAt < since || occurredAt <= newestAt) continue;
        newest = entry;
        newestAt = occurredAt;
    }
    return newest;
}

/** Whether the next, older history page could still hold a payment made at or after `sinceIso`. */
export function olderHistoryMayHoldPayment(page: HistoryPage, sinceIso: string, pagesRead: number): boolean {
    const since = Date.parse(sinceIso);
    if (Number.isNaN(since) || pagesRead >= PAYMENT_SCAN_PAGE_CAP || page.meta.currentPage >= page.meta.lastPage) {
        return false;
    }
    const times = page.entries.map((entry) => Date.parse(entry.occurredAt)).filter((time) => !Number.isNaN(time));
    return times.length > 0 && Math.min(...times) >= since;
}
